__turbopack_context__.v({
  "accordionSlideOverwrite": "dropdownMenu-module-scss-module__z4brpG__accordionSlideOverwrite",
  "dropdownMenu__checkboxItem": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__checkboxItem",
  "dropdownMenu__content": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__content",
  "dropdownMenu__group": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__group",
  "dropdownMenu__insetGroup": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__insetGroup",
  "dropdownMenu__item": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__item",
  "dropdownMenu__itemDescription": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__itemDescription",
  "dropdownMenu__label": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__label",
  "dropdownMenu__portal": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__portal",
  "dropdownMenu__radioGroup": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__radioGroup",
  "dropdownMenu__radioItem": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__radioItem",
  "dropdownMenu__separator": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__separator",
  "dropdownMenu__subContent": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__subContent",
  "dropdownMenu__subTrigger": "dropdownMenu-module-scss-module__z4brpG__dropdownMenu__subTrigger",
  "fadeIn": "dropdownMenu-module-scss-module__z4brpG__fadeIn",
  "fadeOut": "dropdownMenu-module-scss-module__z4brpG__fadeOut",
  "icon": "dropdownMenu-module-scss-module__z4brpG__icon",
  "indicator": "dropdownMenu-module-scss-module__z4brpG__indicator",
  "scaleIn": "dropdownMenu-module-scss-module__z4brpG__scaleIn",
  "scaleOut": "dropdownMenu-module-scss-module__z4brpG__scaleOut",
  "zoomIn": "dropdownMenu-module-scss-module__z4brpG__zoomIn",
  "zoomOut": "dropdownMenu-module-scss-module__z4brpG__zoomOut",
});
